import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import DeviceManagementModals from '~/DeviceManagementModals';
import ChatbotEntryPoint from '~/features/chatbot/components/EntryPoint/ChatbotEntryPoint';
import ChatbotPopup from '~/features/chatbot/components/ChatbotPopup';
import { env } from '~/env';

const { chatbot } = env.featureToggles;

export const ApplicationContentWrapper = ({ children }) => {
    const [isChatbotOpen, setIsChatbotOpen] = useState(false);
    const isLoggedIn = useSelector((state) => {
        const hasToken = Boolean(state.tokenHandling?.accessToken);
        const hasProfile = Boolean(state.login?.userProfile);
        const sessionExpired = state.login?.userSessionExpired;
        const userLoaded = state.ui?.errors?.userLoaded;
        return hasToken && hasProfile && !sessionExpired && userLoaded !== false;
    });

    const handleChatbotClick = () => {
        setIsChatbotOpen((prev) => !prev);
    };

    const handleChatbotClose = () => {
        setIsChatbotOpen(false);
    };

    return (
        // container-fluid fluid-large
        <React.Fragment id='devicemanagement devicemanagement-frame'>
            {/*<ReloadProgress period={20000}/>*/}
            <DeviceManagementModals/>
            <React.Fragment id='devicemanagement-frame-content'>
                {children}
            </React.Fragment>
            {isLoggedIn && chatbot && (
                <>
                    <ChatbotEntryPoint onClick={handleChatbotClick} isActive={isChatbotOpen} />
                    <ChatbotPopup isOpen={isChatbotOpen} onClose={handleChatbotClose} />
                </>
            )}
        </React.Fragment>
    );
};

export default ApplicationContentWrapper;
